module.exports = __webpack_public_path__ + "img/Slide_2.9464d07e.png";